import { Loader } from '@calendly/ui/components/loader';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadData, resetData } from 'actions/home_bar/scope_dropdown';
import { useGetOrganizationQuery } from 'common';
import { dataSelector, isDataPresentSelector } from 'selectors/home_bar';
import EmptyState from './empty_state';
import List from './list';
import SingleState from './single_state';
const loaderCss = "l111hl4k";
const Body = () => {
  const dispatch = useDispatch();
  const data = useSelector(dataSelector);
  const isDataPresent = useSelector(isDataPresentSelector);
  const {
    data: {
      kind: organizationKind
    }
  } = useGetOrganizationQuery();
  const isMultipleOrganization = organizationKind === 'multiple';
  useEffect(() => {
    dispatch(loadData());
    return () => dispatch(resetData());
  }, [dispatch]);
  if (!data) return <Loader className={loaderCss} />;
  if (!isDataPresent) return <EmptyState />;
  if (!isMultipleOrganization) return <SingleState />;
  return <List />;
};
export default Body;

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");